<template>
  <div class="mt-2 md:mt-3">
    <v-select
      :clearable="false"
      class="v-select v-select-search"
      label="label"
      :placeholder="placeholder"
      :filterable="false"
      :options="options"
      @search="onSearch"
      @input="setSelected"
      @search:focus="onFocus"
      @search:blur="onBlur"
    >
      <template #header>
        <label class="block mb-1 font-bold">{{ label }}</label>
      </template>
      <template #selected-option="{ label }">
        <div class="max-w-full truncate">{{ label }}</div>
      </template>
       <template v-slot:no-options="{ searching }">
          <template v-if="searching">
            {{ $t("sidebar.notFound") }}
          </template>
          <em class="opacity-50" v-else>{{ $t('sidebar.searchPlaceholder') }}</em>
        </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash-es/debounce';
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { mapState } from 'vuex';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  props: {
    label: String,
    placeholder: String
  },
  data: function () {
    return {
      options: []
    };
  },
  components: {
    vSelect
  },
  computed: {
    ...mapState({
      language: state => state.language
    })
  },
  methods: {
    onSearch (search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    onFocus () {
    },
    onBlur () {
    },
    search: debounce(async (loading, search, vm) => {
      try {
        vm.options = [];
        const { data: { response } } = await axios.get(`${API_URL}/${vm.language.locale}/getTypeListFromInstantSearch/${search}`);
        if (!response.items?.length) {
          loading(false);
          return;
        }
        vm.options = response.items.map(item => {
          const name = item.attributes.result;
          return {
            label: name.slice(name.indexOf(' - ') + 3, name.length),
            value: item.attributes.id
          };
        });
        loading(false);
      } catch (err) {
        console.log(err);
        vm.$toasted.show(err);
      }
    }, 350),
    setSelected (value) {
      this.$emit('selected', value.value);
    }
  }
};
</script>

<style lang="postcss">
.v-select-search.v-select.vs--open .vs__search::placeholder {
  @apply opacity-0
}
</style>
